import {useNavigate, useParams} from "react-router-dom";
import {Button} from "primereact/button";
import React, {useEffect, useState} from "react";
import {Dialog} from "primereact/dialog";
import {useGetKpiTargetQuery} from "../../apis/kpiApi";
import KPIValueTargetQuarterDisplay from "./KPIValueTargetQuarterDisplay";
import {DateTime} from "luxon";
import KPIValueTargetAnnualDisplay from "./KPIValueTargetAnnualDisplay";
import KPIValueTargetQuarterlyEntries from "./KPIValueTargetQuarterlyEntries";
import {getTargetQuarter} from "../../hooks/kpiHooks";
import {useSelector} from "react-redux";

const KPIValueTargetPopup = () => {
    const { target } = useParams();
    const navigate = useNavigate();
    const selectedYear = useSelector(state => state.kpi.selectedYear);
    const {data: kpiTarget, isLoading: isLoadingTarget} = useGetKpiTargetQuery(target);
    const [selectedQuarter, setSelectedQuarter] = useState(selectedYear < DateTime.now().year ? 3 : selectedYear > DateTime.now().year ? 0 : DateTime.now().quarter - 1);

    useEffect(() => {
        if(isLoadingTarget || !kpiTarget) return;

        if(kpiTarget?.timeFrame === 'Quarter') {
            setSelectedQuarter(getTargetQuarter(kpiTarget));
        }
    }, [kpiTarget, isLoadingTarget]);

    if(isLoadingTarget) {
        return (<></>);
    }

    const onHide = () => {
        navigate(-1);
    }

    const renderFooter = () => {
        return (
            <div>
                <Button type="button" label="Close" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
            </div>
        );
    }

    return (
        <Dialog modal={true} header={`${kpiTarget.name} (WEIGHT: ${kpiTarget.weight})`} visible={true} style={{ width: '50vw', height: '80vw' }} footer={renderFooter()} onHide={() => onHide()}>
            <div className="kpi-value-targets-by-quarter">
                <div className="quarter-labels">
                    <div>Goals</div>
                    <div>Actual</div>
                </div>
                <KPIValueTargetQuarterDisplay target={kpiTarget} quarter={0} selected={selectedQuarter === 0} setSelectedQuarter={setSelectedQuarter} />
                <KPIValueTargetQuarterDisplay target={kpiTarget} quarter={1} selected={selectedQuarter === 1} setSelectedQuarter={setSelectedQuarter} />
                <KPIValueTargetQuarterDisplay target={kpiTarget} quarter={2} selected={selectedQuarter === 2} setSelectedQuarter={setSelectedQuarter} />
                <KPIValueTargetQuarterDisplay target={kpiTarget} quarter={3} selected={selectedQuarter === 3} setSelectedQuarter={setSelectedQuarter} />
                <KPIValueTargetAnnualDisplay target={kpiTarget} />
            </div>
            <KPIValueTargetQuarterlyEntries target={kpiTarget} quarter={selectedQuarter} />
        </Dialog>
    );
}

export default KPIValueTargetPopup;
